const tickerNegative = {
    svg: '<svg style="width:0.75rem; height:0.75rem;" viewBox="0 0 12 12"><polygon points="1.5 11 6 1 10.5 11" transform="translate(6.000000, 6.000000) rotate(180.000000) translate(-6.000000, -6.000000)"/></svg>',
};

export { tickerNegative as default };
